import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const MetricCard = ({
  title,
  value,
  trend,
  trendLabel = "vs last week",
  icon: Icon,
  iconBgColor = "bg-[#E8F8F0]",
  iconColor = "text-[#10B981]",
  isPositiveTrend = true,
}) => {
  return (
    <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">{title}</span>
        {Icon && (
          <div className={`w-9 h-9 rounded-full flex items-center justify-center ${iconBgColor}`}>
            <Icon className={`w-4 h-4 ${iconColor}`} />
          </div>
        )}
      </div>

      <div className="mt-2">
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">{value}</h3>
      </div>

      <div className="flex items-center gap-1 mt-2 text-xs font-semibold">
        {isPositiveTrend ? (
          <TrendingUp className="w-3.5 h-3.5 text-[#10B981]" />
        ) : (
          <TrendingDown className="w-3.5 h-3.5 text-[#10B981]" />
        )}
        <span className="text-[#10B981] font-semibold">{trend}</span>
        <span className="text-gray-400 font-normal">{trendLabel}</span>
      </div>
    </div>
  );
};

export default MetricCard;
